module.exports = __webpack_public_path__ + "static/media/data_analytics__monochromatic.3bbbd9ef.svg";